export default __webpack_public_path__ + "static/media/primary.37b32823.jpg";